











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleFeatureFlagMutation_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OwnedFeatureFlag",
      "kind": "LinkedField",
      "name": "featureFlag",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "featureName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ToggleFeatureFlagSuccess",
  "abstractKey": null
};

(node ).hash = "365c069a195a3d99f8281273b631702a";

export default node;
